export default "__VITE_ASSET__6dkmeIrw__"